import { Button } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { Box } from '@mui/system';
import * as React from 'react';
import { useNavigate, Link } from 'react-router-dom';

import Grid, { QueryOptions } from '../Grid';
import { AppContext } from '../../AppContext';

const columns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'name',
    filterable: true,
    sortable: true,
    renderCell: ({row}: any) => (<Link to={`/aiagents/${row?.id}`}>{row?.name}</Link>)
  },
];


export default function AiAgentsPage() {
  const {client, notificationsService, user} = React.useContext(AppContext);
  const navigate = useNavigate();

  const fetchData = async (options: QueryOptions) => {
    const result = await client<any, any>({
      event: 'aiagents.getAll',
      data: options as any
    })

    if (result.success) {
      return result.value
    } else {
      notificationsService.notify({
        severity: 'error',
        message: `Error: ${JSON.stringify(result.errors)}`
      });

      return {data: [], pageInfo: {}}
    }
  };


  return <Box sx={{display: 'flex', flexDirection: 'column', height: '100%' }}>
    <Box sx={{marginBottom: 1}}>
      {
        user.role === "admin" || user.role === "manager"
        ? (<Button
          variant="contained"
          onClick={() => navigate('/aiagents/new')}
        >
          CREATE NEW AI AGENT
        </Button>)
        : <></>
      }
    </Box>
    <Box sx={{flexGrow: 1}}>
      <Grid
        cacheName={'aiagents'}
        columns={columns}
        fetchData={fetchData}
        onRowClick={(id) => {}}
        showSearch={true}
      />
    </Box>
  </Box>
}
